import { useEffect } from 'react';
import { installExtractedScreens } from '../features/extractedScreens';
import { loadClassicScript } from './loadClassicScript';
import { RUNTIME_SCRIPTS } from './runtimeScripts';

declare global {
  interface Window { __QC_REACT_RUNTIME_STARTED__?: boolean }
}

async function bootLegacyRuntime(): Promise<void> {
  for (const script of RUNTIME_SCRIPTS) {
    await loadClassicScript(script.src);
    /* Extracted screens must own their window bindings before app.js's boot
       promise (which awaits its data fetches) can call route() — installing
       here, synchronously after app.js executes, guarantees even the first
       paint goes through React. */
    if (script.feature === 'application') installExtractedScreens();
  }
}

export function useLegacyRuntime(): void {
  useEffect(() => {
    if (window.__QC_REACT_RUNTIME_STARTED__) return;
    window.__QC_REACT_RUNTIME_STARTED__ = true;

    bootLegacyRuntime().catch((error: unknown) => {
      window.__QC_REACT_RUNTIME_STARTED__ = false;
      console.error('[Quran Club] Runtime bootstrap failed', error);
    });
  }, []);
}
